module Internal.Luxon
    ( LDateTime
    , now
    , fromISO
    , toISO
    , toISONoTZ
    , toMillis
    , toRelative
    , toFormat
    , prettyPrint
    ) where

import Common

import Data.Argonaut (class DecodeJson, class EncodeJson)
import Data.Argonaut.Decode.Decoders (decodeString)
import Data.Argonaut.Encode.Encoders (encodeString)
import Data.Either (note)
import Data.Function.Uncurried (Fn2, runFn2)

foreign import data LDateTime :: Type

foreign import now :: Effect LDateTime

foreign import toISO :: LDateTime -> String
foreign import toISONoTZ :: LDateTime -> String
foreign import toMillis :: LDateTime -> Number
foreign import toRelative :: LDateTime -> String
foreign import toFormat :: String -> LDateTime -> String
foreign import showDateTime :: LDateTime -> String

foreign import dateTimeEq :: LDateTime -> LDateTime -> Boolean

foreign import fromISOInternal :: forall a. Fn2 (a -> Maybe a) (Maybe a) (String -> Maybe LDateTime)
fromISO :: String -> Maybe LDateTime
fromISO = runFn2 fromISOInternal Just Nothing

instance showLDT :: Show LDateTime where
    show = showDateTime

instance decodeLDT :: DecodeJson LDateTime where
    decodeJson json = do
       str <- decodeString json
       note (TypeMismatch "DateTime") $ fromISO str

instance encodeLDT :: EncodeJson LDateTime where
    encodeJson = encodeString <<< toISO

instance eqLDT :: Eq LDateTime where
    eq = dateTimeEq

prettyPrint :: LDateTime -> String
prettyPrint = toFormat "LLL dd, yyyy t"
